import "../global.d.js";
import { validateTidalLicense } from "@workwave-tidal/license-utils";
import { validateTidalLicense as validateTidalLicense2 } from "@workwave-tidal/license-utils";
export * from "./getShouldForwardProp.js";
export * from "./isDev.js";
export * from "./printTidalVersions.js";
export * from "./registerTidalVersion.js";
export * from "./utilityTypes.js";
validateTidalLicense();
export {
  validateTidalLicense2 as validateTidalLicense
};
//# sourceMappingURL=index.js.map
